import { render, staticRenderFns } from "./DeleteDocumentType.vue?vue&type=template&id=08c1c0d8&"
import script from "./DeleteDocumentType.vue?vue&type=script&lang=ts&"
export * from "./DeleteDocumentType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports